export default "__VITE_ASSET__9B9Ml6cm__"